// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class ReportType {
    public static readonly STANDARD: string = 'Standard';
    public static readonly SUPPLEMENTAL: string = 'Supplemental';
    public static readonly SPECIALELECTION: string = 'Special Election';
}
